import { useState } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Divider,
  Link,
  CircularProgress,
} from "@mui/material";
import loginBg from "../assets/images/lap_image.jpg";
import logo from "../assets/images/logo.png";
import adminLoginBg from "../assets/images/background.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import signup from "../assets/images/signup.png";
import DevOpsandSRE from "../assets/images/DevOpsandSRE.png";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();

  const isBusinessEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@sandhata\.com$/;
    if (!emailRegex.test(email)) return false;
    const freeDomains = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com"];
    const domain = email.split("@")[1].toLowerCase();
    return !freeDomains.includes(domain);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value.trim();
    setEmail(value);
    setError(false);
    setHelperText("");

    if (!value) {
      setError(true);
      setHelperText("Email is required");
      setDisabled(true);
      return;
    }
    if (!isBusinessEmail(value)) {
      setError(true);
      setHelperText("Please enter a valid business email");
      setDisabled(true);
      return;
    }
    setDisabled(false);
  };

  const handleLogin = async () => {
    if (disabled) return;
    setLoading(true);
    try {
      const response = await instance.loginPopup({
        ...loginRequest,
        loginHint: email,
      });
      console.log("Login successful:", response);
      navigate("/admin/select-domain");
    } catch (err) {
      console.error("Login failed:", err);
      setError(true);
      setHelperText("Authentication failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        // height: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F5F6F8",
      }}
    >
      {/* === Layer 1: Background Image === */}
      {/* <Box
        sx={{
          position: "absolute",
          inset: 0,
          // backgroundImage: `url(${adminLoginBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          transform: "scale(1.05)",
          zIndex: 0,
        }}
      /> */}

      {/* === Layer 2: Progressive Layer Blur === */}
      {/* <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          pointerEvents: "none",
          background: 'white'
        }}
      /> */}

      {/* === Layer 3: Ambient Conic Gradient Overlay === */}
      {/* <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 2,
          // background:
          //   "conic-gradient(from -7.72deg at 100% 100%, rgba(0,0,0,0.8) 0deg, rgba(73,69,79,0.4) 294.45deg, rgba(0,0,0,0.85) 360deg)",
          background: 'white',
          mixBlendMode: "overlay",
          opacity: 0.9,
        }}
      /> */}

      {/* === Frosted Card === */}
      <Box
        sx={{
          display: "flex",
          // width: "60vw",
          width: { xs: "70%", sm: "70%", md: "70%", lg: "70%", xl: "65%" },
          height: { xs: "80%", sm: "80%", md: "80%", lg: "88%", xl: "80%" },
          borderRadius: "1.25rem",
          border: "1px solid #E0E0E0",
          backgroundColor: "#FFF",
          // padding: { xs: "24px", sm: "24px", md: "24px", lg: "24px", xl: "24px" },
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: "50%",
            borderRadius: "2rem",
            background: "transparent",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={DevOpsandSRE}
            alt="Auth Illustration"
            // sx={{
            //   width: "100%",
            //   height: "auto",
            //   objectFit: "contain",
            // }}
            sx={{
              width: { xs: "90%", sm: "90%", md: "90%", lg: "90%", xl: "90%" },
              height: { xs: "90%", sm: "90%", md: "90%", lg: "90%", xl: "90%" },
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Box>
        <Box
          sx={{
            width: "47%",
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            overflowY: "auto",
            height: "90%",
            gap: 2,
            mt: 5,       // ⭐ uniform gap between logo and form
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",   // ⭐ center vertically when content is small
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Sandhata Logo"
              sx={{
                width: "162px",
                height: "30px",
                alignSelf: "flex-start",
                mb: 2
              }}
            />
            <Box sx={{
              width: {
                xs: "90%",
                sm: "90%",
                md: "80%",
                lg: "95%",
                xl: "80%",
              },
              display: "flex",
              flexDirection: "column",
              gap: 3, // ⭐ uniform spacing for EVERYTHING
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                <Typography
                  sx={{
                    color: "#0036DD",
                    fontFamily: "Akkurat-Bold",
                    fontSize: {
                      xs: "1rem",
                      sm: "1rem",
                      md: "1rem",
                      lg: "18px",
                      xl: "20px",
                    },
                  }}
                >
                  DevOps and SRE Admin Portal
                </Typography>
                <Typography
                  variant="body2"
                  align="left"
                  // mb={3}
                  sx={{
                    color: "#525252",
                    fontFamily: "Akkurat-Pro",
                    fontWeight: 400,
                    fontSize: {
                      xs: "0.7rem",
                      sm: "0.7rem",
                      md: "0.7rem",
                      lg: "12px",
                      xl: "0.8rem",
                    },
                  }}
                >
                  Log in to manage and monitor the DevOps and SRE Compass.
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                sx={{
                  color: "#525252",
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.8rem",
                    md: "0.8rem",
                    lg: "0.75rem",
                    xl: "1rem",
                  },
                  fontFamily: "Akkurat-Pro",
                }}
              >
                Business email*
              </Typography>
              <Box
                sx={{
                  borderRadius: "1.75rem",
                  border: "1px solid #E0E0E0",
                  pl: 1,
                  height: "35px",
                  width: "98%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TextField
                  variant="standard"
                  value={email}
                  onChange={handleEmailChange}
                  error={error}
                  placeholder="i.e. john.doe@sandhata.com"
                  slotProps={{ input: { disableUnderline: true } }}
                  margin="normal"
                  sx={{
                    width: "100%",
                    "& input": {
                      fontSize: "0.72rem",
                      fontFamily: "Akkurat-Pro",
                    },
                    /* REMOVE CHROME AUTOFILL BLUE BACKGROUND */
                    "& input:-webkit-autofill": {
                      WebkitBoxShadow: "0 0 0 1000px white inset !important",
                      WebkitTextFillColor: "#000 !important",
                      caretColor: "#000",
                    },
                  }}
                />
              </Box>
              {error && (
                <Typography
                  ml={2}
                  variant="caption"
                  sx={{ color: "whitesmoke", mt: 0.5 }}
                >
                  {helperText}
                </Typography>
              )}
            </Box>

            <Button
              type="button"
              variant="contained"
              sx={{
                mt: 1,
                py: 1,
                borderRadius: 7,
                width: "45%",
                alignSelf: "left",
                color: "black",
                backgroundColor: disabled ? "grey" : "#1565c0",
                ":disabled": { backgroundColor: "whitesmoke" },
              }}
              disabled={disabled || loading}
              onClick={handleLogin}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}